// @generated by protoc-gen-es v1.10.0
// @generated from file ai/h2o/mlops/deployer/v1/vpa_resource_spec.proto (package ai.h2o.deploy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { ResourceUnit } from "./resource_unit_pb.js";

/**
 * Represents resource specifications for a Vertical Pod Autoscaler (VPA).
 *
 * CPU and Memory are the only resources supported by VPA.
 * VPA can be extended to manage other resources like GPU usage or Storage.
 *
 * @generated from message ai.h2o.deploy.VpaResourceSpec
 */
export const VpaResourceSpec = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.deploy.VpaResourceSpec",
  () => [
    { no: 1, name: "cpu", kind: "message", T: VpaResourceBounds },
    { no: 2, name: "memory", kind: "message", T: VpaResourceBounds },
  ],
);

/**
 * Represents the bounds of a resource for a Vertical Pod Autoscaler (VPA) in a given unit.
 *
 * @generated from message ai.h2o.deploy.VpaResourceBounds
 */
export const VpaResourceBounds = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.deploy.VpaResourceBounds",
  () => [
    { no: 1, name: "unit", kind: "enum", T: proto3.getEnumType(ResourceUnit) },
    { no: 2, name: "max", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "min", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
);

